import { environment } from '../../../../environments/environment';

export class DocumentService {
  static $inject = ['RestResource', 'UtilService', '$translate', 'WindowModalService'];

  constructor(
    private RestResource,
    private UtilService,
    private $translate,
    private WindowModalService
  ) {}

  utils = new this.UtilService(this);

  // Send document to factun/hacienda as the status was fail
  // The document was generated internally but not in factun/hacienda
  sendDocumentToAtv(item, documentType) {
    let apiUrl = environment.apiEndpoint + documentType + '/' + item.id + '/send_document_to_atv';

    return this.RestResource.request(
      'put',
      apiUrl,
      { company_id: item.company_id },
      (response) => {
        this.utils._successMsg(this.$translate.instant('UPDATED_DOCUMENT'));

        return response.data;
      },
      () => {
        this.utils._errorMsg(this.$translate.instant('FAILED_RETRY'));

        return false;
      }
    );
  }

  // Update status or re-send document(not_sent')
  resendDocumentToAtv(item, documentType) {
    let apiUrl = environment.apiEndpoint + documentType + '/' + item.id + '/resend_document_to_atv';

    return this.RestResource.request(
      'put',
      apiUrl,
      { company_id: item.company_id },
      (response) => {
        this.utils._successMsg(this.$translate.instant('UPDATED_DOCUMENT'));

        return response.data;
      },
      () => {
        this.utils._errorMsg(this.$translate.instant('FAILED_RETRY'));

        return false;
      }
    );
  }

  getDocumentFromAtv(item, documentType) {
    let apiUrl = environment.apiEndpoint + documentType + '/' + item.id + '/get_document_from_atv';

    return this.RestResource.request(
      'put',
      apiUrl,
      { company_id: item.company_id },
      (response) => {
        return response.data;
      },
      () => {
        this.utils._errorMsg(this.$translate.instant('FAILED_RETRY'));

        return false;
      }
    );
  }

  notifyDocumentToClient(item, documentType, email) {
    let apiUrl =
      environment.apiEndpoint + documentType + '/' + item.id + '/notify_document_to_client';

    return this.RestResource.request(
      'put',
      apiUrl,
      { company_id: item.company_id, client_email_receipt: email },
      (response) => {
        this.utils._successMsg(this.$translate.instant('DOCUMENT_SENT_TO_CLIENT'));

        return response.data;
      },
      () => {
        this.utils._errorMsg(this.$translate.instant('FAILED_RETRY'));

        return false;
      }
    );
  }

  openNotifyDocumentToClient(email, succesCallBack, title) {
    let templateUrl =
      './app/ajs/_shared/components/notify-document-to-client/notify-document-to-client-modal.html';

    let modalParams = {
      item: email,
      title: title,
    };

    let confirmCallback = function (emailObj) {
      return succesCallBack(emailObj);
    };

    this.WindowModalService.open(templateUrl, modalParams, confirmCallback);
  }
}
